import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41725a74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selector-container" }
const _hoisted_2 = { class: "company-logo" }
const _hoisted_3 = { class: "company-logo" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["knight-selector", _ctx.knightSelectedClass]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.knightClicked && _ctx.knightClicked(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CompanyLogo, { company: "knight" })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["swift-selector", _ctx.swiftSelectedClass]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.swiftClicked && _ctx.swiftClicked(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CompanyLogo, { company: "swift" })
      ])
    ], 2)
  ]))
}